import React from "react";

import { IMenuFooter } from "../../menu.interface";

interface IProps {
    navFooterEl: IMenuFooter;
}

export const NavFooter = (props: IProps) => {
    return (
        <div className="main-dropdown-menu__footer l-full-width">
            {/* TODO(i18n): HTML content comes from CMS and should be translated there, not here */}
            <div
                className="l-capped-width"
                dangerouslySetInnerHTML={{
                    __html: props.navFooterEl.value.html,
                }}
            ></div>
        </div>
    );
};
